'use client';

import { c as _c } from "react/compiler-runtime";
import { useDeviceInfoStore, WEBVIEW_TYPE } from '@/stores/DeviceStore';
export const useAdGuards = () => {
  const $ = _c(2);
  const isWelloApp = useDeviceInfoStore(_temp);
  let t0;
  if ($[0] !== isWelloApp) {
    t0 = {
      isWelloApp
    };
    $[0] = isWelloApp;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
function _temp(state) {
  return state.webviewType === WEBVIEW_TYPE.WELLO_APP;
}